import Settings from './Settings'

export {Settings};


// WEBPACK FOOTER //
// ./src/app/screens/Settings/index.js